import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import faker from 'faker';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  plugins: {
    legend: {
      //position: 'top' as const,
    },
    title: {
      display: true,
      text: 'Profitability Bar Chart',
    },
  },
};

const labels = ['Cost for Trips with Market Vehicles', 'Cost for Trips with Own Vehicles',
  'Cost for Vehicle Maintenance', 'Market Freight',
  'Market Total Charges', 'Market Total Deductions',
  'Number of Trips started in Month', 'Overall Cost in Month',
  'Overall Profit in Month', 'Overall Revenue in Month',
  'Owned Freight', 'Owned Total Charges',
  'Owned Total Deductions', 'Profit from Market Vehicles',
  'Profit from Own Vehicles', 'Revenue from Market Vehicles',
  'Revenue from Owned Dedicated'
];


export const data = {
  labels,
  /* datasets: [
    {
      label: 'Dataset 1',
      data: labels.map(() => faker.datatype.number({ min: 0, max: 1000 })),
      backgroundColor: 'rgba(255, 99, 132, 0.5)',
    }
  ], */
};


export function BarChart({ ...props }) {

  const DataReceived = [
    props.tripProfitabilityReportDataMap.Cost_for_Trips_with_Market_Vehicles,
    props.tripProfitabilityReportDataMap.Cost_for_Trips_with_Own_Vehicles,
    props.tripProfitabilityReportDataMap.Cost_for_Vehicle_Maintenance,
    props.tripProfitabilityReportDataMap.Market_Freight,
    props.tripProfitabilityReportDataMap.Market_Total_Charges,
    props.tripProfitabilityReportDataMap.Market_Total_Deductions,
    props.tripProfitabilityReportDataMap.Number_of_Trips_started_in_Month,
    props.tripProfitabilityReportDataMap.Overall_Cost_in_Month,
    props.tripProfitabilityReportDataMap.Overall_Profit_in_Month,
    props.tripProfitabilityReportDataMap.Overall_Revenue_in_Month,
    props.tripProfitabilityReportDataMap.Owned_Freight,
    props.tripProfitabilityReportDataMap.Owned_Total_Charges,
    props.tripProfitabilityReportDataMap.Owned_Total_Deductions,
    props.tripProfitabilityReportDataMap.Profit_from_Market_Vehicles,
    props.tripProfitabilityReportDataMap.Profit_from_Own_Vehicles,
    props.tripProfitabilityReportDataMap.Revenue_from_Market_Vehicles,
    props.tripProfitabilityReportDataMap.Revenue_from_Owned_Dedicated,
  ]

  data.datasets = [
    {
      label: 'Dataset 1',
      data: DataReceived,
      backgroundColor: '#00A244',
    },
  ]

  return <Bar options={options} data={data} />;
}
